import { useEffect } from 'react';
import useApi from './useApi';
import { useTankCleaningStore } from '../context/TankCleaningContext';
import { createChemicalList } from '../factory/TankCleaning/ChemicalFactory';
import { createSupplierList } from '../factory/SupplierFactory';
import { createUnitList } from '../factory/UnitFactory';
import { createCategoryList } from '../factory/TankCleaning/CategoryFactory';
import { createRobLocationDDList } from '../factory/TankCleaning/ChemicalRobLocationDDFactory';
import useApiEndpoints from '../context/useApiEndpoints';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import { createChemicalOrderPortCallList } from '../factory/TankCleaning/ChemicalOrderPortCallFactory';
import { createChemicalRobPortCallList } from '../factory/TankCleaning/ChemicalRobPortCallFactory';
import mapTankCleaningUtils from '../utils/mapTankCleaningUtils';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();
    const {
        setChemicalList,
        setChemicalSupplierList,
        setChemicalUnitList,
        setChemicalCategoryList,
        setRobLocationDDList,
        setChemicalOrderForPortCallList,
        setChemicalRobForPortCallList,
        setMappedChemicalList,
    } = useTankCleaningStore();
    const { mapChemicalList } = mapTankCleaningUtils();

    const getChemicalRobs = (imoNumber: number) => {
        return getApiData({
            endpoint: apiEndpoints['getChemicalRobs'].url,
            queryParam: buildQueryParams({ imoNumber }),
        });
    };

    const getChemicalOrders = (imoNumber: number) => {
        return getApiData({
            endpoint: apiEndpoints['getChemicalOrders'].url,
            queryParam: buildQueryParams({ imoNumber }),
        });
    };

    const getChemicalData = async (imoNumber: number) => {
        const robs = await getChemicalRobs(imoNumber);
        const orders = await getChemicalOrders(imoNumber);

        const chemicalOrdersForPortCallBMs = orders as any;
        const chemicalOrdersForPortCalls = createChemicalOrderPortCallList(chemicalOrdersForPortCallBMs);

        if (chemicalOrdersForPortCalls) {
            setChemicalOrderForPortCallList([...chemicalOrdersForPortCalls]);
        } else {
            setChemicalOrderForPortCallList([]);
        }

        const chemicalRobForPortCallBMs = robs as any;
        const chemicalRobForPortCalls = createChemicalRobPortCallList(chemicalRobForPortCallBMs);

        if (chemicalRobForPortCalls) {
            setChemicalRobForPortCallList([...chemicalRobForPortCalls]);
        } else {
            setChemicalRobForPortCallList([]);
        }
    };

    const getChemicalConfigData = () => {
        getApiData({
            endpoint: apiEndpoints['getChemicalConfigData'].url,
        });
    };

    useEffect(() => {
        if (state.status === 'success' && state.endpoint === apiEndpoints['getChemicalConfigData'].url) {
            const chemicalData = state.result as any;
            const categoryList = createCategoryList(chemicalData.chemicalCategoryList);
            setChemicalCategoryList([...categoryList]);
            const supplierList = createSupplierList(chemicalData.chemicalSupplierList);
            setChemicalSupplierList([...supplierList]);
            const unitList = createUnitList(chemicalData.chemicalUnitList);
            setChemicalUnitList([...unitList]);
            const chemicalList = createChemicalList(chemicalData.chemicalList);
            setChemicalList([...chemicalList]);
            const robLocationDDList = createRobLocationDDList(chemicalData.robLocationDropdownList);
            setRobLocationDDList([...robLocationDDList]);

            const _chemicalList = mapChemicalList(chemicalList, categoryList, supplierList, unitList);
            setMappedChemicalList(_chemicalList);
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { state, getChemicalConfigData, getChemicalData, getChemicalRobs, getChemicalOrders };
};
